import type { ReactNode } from 'react';

export const symbol_settings_overscan: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M263-536q0-5.25-4.5-7.13Q254-545 250-541l-51 50q-5 4.64-5 10.82 0 6.18 5 11.18l51 50q4 4 8.5 2.12 4.5-1.87 4.5-7.12v-112Zm273 192H425q-5 0-7.5 4.5t1.5 8.5l50 51q4.64 5 10.82 5 6.18 0 11.18-5l50-51q4-4 2.13-8.5-1.88-4.5-7.13-4.5Zm0-272q5.25 0 7.13-4.5Q545-625 541-629l-50-50q-4.64-5-10.82-5-6.18 0-11.18 5l-49 50q-4 4-2.12 8.5 1.87 4.5 7.12 4.5h111Zm163 80v113q0 5.25 4.5 7.12Q708-414 712-418l50-50q5-5 5.5-11t-4.5-11l-51-51q-4-4-8.5-2.13-4.5 1.88-4.5 7.13ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
